import { useCallback, useEffect, useState } from 'react'
import 'flowbite'
import './tabs.scss'

export interface TabItem {
  title: string
  slot: string
}

enum Direction {
  Left = 'left',
  Right = 'right',
}

export const Tabs = ({
  tabs,
  WebPush,
  Popunder,
  InPage,
  Video,
  Banner,
  Native,
}: {
  tabs: TabItem[]
  WebPush?: React.ReactNode
  Popunder?: React.ReactNode
  InPage?: React.ReactNode
  Video?: React.ReactNode
  Banner?: React.ReactNode
  Native?: React.ReactNode
}) => {
  const [openedIndex, setOpenedIndex] = useState(0)
  const [touchStart, setTouchStart] = useState(0)
  const [touchEnd, setTouchEnd] = useState(0)
  const adformats = document.getElementById('ad-formats')
  const indicator = document.querySelector(
    `#${tabs[openedIndex].slot}-indicators`
  )
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    const sessionParams = JSON.parse(localStorage.getItem('query'))
    const queryParams = Object.fromEntries(new URLSearchParams(window.location.search))

    const params = { ...sessionParams, ...queryParams }
    const searchParams = new URLSearchParams()
    Object.keys(params)
      .forEach(key => searchParams.append(key, params[key]))

    if (searchParams.size) {
      document
        .querySelectorAll(
          '#webpush-btn,#popunder-btn,#inpage-btn,#video-btn,#banner-btn,#native-btn'
        )
        .forEach((btn) => {
          if (btn.href && !btn.href.includes('?')) {
            btn.href += `?${searchParams.toString()}`
          }
        })
    }
  })

  function renderIndicator() {
    if (!indicator) return
    indicator.innerHTML = ''
    for (let i = 0; i < tabs.length; i++) {
      const button = document.createElement('button')
      button.ariaLabel = `Indicator ${i}`
      i === openedIndex
        ? button.classList.add('active-indicator')
        : button.classList.remove('active-indicator')

      button.onclick = (function (index: number) {
        return () => changeActive(index)
      })(i)

      indicator?.appendChild(button)
    }
  }

  const changeActive = useCallback(
    (index: number) => {
      const hashedTab = tabs[index]
      if (hashedTab) {
        setOpenedIndex(index)
        adformats?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start',
        })
      }
    },
    [tabs]
  )

  useEffect(() => {
    const adformats = document.getElementById('ad-formats')
    const indicator = document.querySelector(
      `#${tabs[openedIndex].slot}-indicators`
    )

    if (indicator) {
      indicator.innerHTML = ''
      tabs.forEach((_, i) => {
        const button = document.createElement('button')
        button.ariaLabel = `Indicator ${i}`
        if (i === openedIndex) {
          button.classList.add('active-indicator')
        }
        button.onclick = () => changeActive(i)
        indicator.appendChild(button)
      })
    }

    if (adformats && isMounted) {
      adformats.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      })
    }
  }, [openedIndex, tabs, changeActive])

  useEffect(() => {
    setIsMounted(true)
  }, [])

  function findDirection() {
    if (touchEnd - touchStart > 50) return Direction.Left
    if (touchEnd - touchStart < -50) return Direction.Right
  }

  const onTouchStart: React.TouchEventHandler<HTMLDivElement> = (
    e: TouchEvent
  ) => {
    setTouchStart(e.touches[0].screenX)
  }

  const onTouchEnd: React.TouchEventHandler<HTMLDivElement> = (
    e: TouchEvent
  ) => {
    setTouchEnd(e.changedTouches[0].screenX)
    const direction = findDirection()
    if (!direction) return
    if (direction === Direction.Right) {
      if (openedIndex < tabs.length - 1) {
        changeActive(openedIndex + 1)
      }
    }
    if (direction === Direction.Left) {
      if (openedIndex > 0) {
        changeActive(openedIndex - 1)
      }
    }
  }

  const onScroll = () => {
    renderIndicator()
  }

  return (
    <div>
      <div className="flex mb-10 mb-24px sm:mb-[40px] relative">
        <div
          className={
            'flex lg:min-w-none gap-2 justify-center overflow-x-auto tabs-header w-full'
          }
        >
          {tabs.map((tab, index) => (
            <div
              key={`title-${tab.title}`}
              className={`header-item cursor-pointer text-center bg-bg-card ${
                openedIndex === index ? 'selected' : ''
              }`}
              dangerouslySetInnerHTML={{ __html: tab.title }}
              onClick={() => setOpenedIndex(index)}
            />
          ))}
        </div>
      </div>
      <div
        key={tabs[openedIndex].slot}
        id="ad-formats-slider"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onScroll={onScroll}
        className="lg:fade-in max-lg:slider max-lg:always-flex"
      >
        {tabs.map((tab, index) => (
          <div
            key={tab.slot}
            style={{ display: openedIndex === index ? 'block' : 'none' }}
          >
            {index === 0 && WebPush}
            {index === 1 && Popunder}
            {index === 2 && InPage}
            {index === 3 && Video}
            {index === 4 && Banner}
            {index === 5 && Native}
          </div>
        ))}
      </div>
    </div>
  )
}
